export default {
  "hero.eyebrow": "Centrum zasobów arkusza USFans",
  "hero.title": "Arkusz USFans — zaktualizowane zasoby, przewodniki i narzędzia",
  "hero.subtitle": "Znajdź zasoby arkusza USFans, przewodniki zakupowe, informacje o sprzedawcach, wskazówki dotyczące wysyłki i kontroli jakości, przewodniki magazynowe, recenzje oraz informacje o bezpieczeństwie — wszystko w jednym wygodnym centrum zasobów.",
  "hero.ctaPrimary": "Arkusz USFans",
  "hero.ctaSecondary": "Kup teraz",
  "hero.ctaGuide": "Zobacz przewodnik",
  "hero.trust": "Zaktualizowane zasoby · Praktyczne przewodniki · Informacje o bezpieczeństwie · Niezależny serwis",

  "categories.title": "Kupuj według kategorii",
  "categories.subtitle": "Przejdź od razu do ulubionej kategorii na stronie głównej.",
  "categories.dropdownLabel": "Przeglądaj kategorie",
  "categories.dropdownPlaceholder": "Wybierz kategorię…",

  "featured.title": "Arkusz USFans — wyjaśniony",
  "featured.body": "Arkusz USFans łączy popularne kategorie produktów, zaktualizowane linki i przydatne informacje zakupowe w jednym, przejrzystym widoku. Niezależnie od tego, czy szukasz sneakersów, trykotów, czy porównujesz opcje wysyłki, arkusz pomaga szybko przejść od poszukiwań do właściwej strony — z linkami prowadzącymi prosto do serwisu głównego.",

  "article.title": "Najnowsze przewodniki i zasoby",
  "article.subtitle": "Pogłębione, oryginalne przewodniki, które pomogą Ci w pełni wykorzystać arkusz USFans.",
  "article.cardTitle": "Kompletny przewodnik po arkuszu USFans 2026",
  "article.excerpt": "Dowiedz się, czym jest arkusz USFans, jak z niego korzystać, jakie kategorie warto sprawdzić oraz jakie podstawy bezpieczeństwa i wysyłki warto znać przed zakupem.",
  "article.readMore": "Przeczytaj pełny przewodnik",

  "why.title": "Dlaczego powstał ten serwis",
  "why.body": "Znalezienie wiarygodnych i aktualnych informacji o arkuszu USFans bywa czasochłonne. To niezależne centrum zasobów porządkuje najważniejsze rzeczy — kategorie, przewodniki i wskazówki bezpieczeństwa — abyś mógł podejmować świadome decyzje bez przeszukiwania rozproszonych stron.",

  "cta.title": "Szukasz najnowszych zasobów USFans?",
  "cta.body": "Odwiedź stronę główną, aby znaleźć dodatkowe informacje, zaktualizowane linki i bieżące promocje.",
  "cta.button": "Odwiedź stronę główną",
};